module.exports = __webpack_public_path__ + "static/media/github.baf48a32.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/github.svg
// module id = 11
// module chunks = 0